import { render, staticRenderFns } from "./BlockForms.vue?vue&type=template&id=6f6a76d8&scoped=true"
import script from "./BlockForms.vue?vue&type=script&lang=js"
export * from "./BlockForms.vue?vue&type=script&lang=js"
import style0 from "./BlockForms.vue?vue&type=style&index=0&id=6f6a76d8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a76d8",
  null
  
)

export default component.exports